// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-body {
  background-color: #EDF2F5;
}

table.filterTable tr td:first-child {
  padding: 2px 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/analysis/jobSatisfactions/components/web/job-satisfactions-reports-filters-modal/job-satisfactions-reports-filters-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ;;AAEA;EACI,iBAAA;AACJ","sourcesContent":[".modal-body {\n    background-color: #EDF2F5;\n}\n\ntable.filterTable tr td:first-child {\n    padding: 2px 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
